module.exports = __webpack_public_path__ + "static/hdw-header-img-c60132dac83e0b7170a53cfa071cca5f.png";